import { MenuDrawer } from "./MenuDrawer";

const SITE_OVERLAY_CLASSNAME = "js-site-overlay";

class SiteOverlay {
  static attach() {
    const $siteOverlayElement = document.querySelector(`.${SITE_OVERLAY_CLASSNAME}`);
    if ($siteOverlayElement) {
      /* eslint-disable-next-line no-unused-vars */
      const siteOverlay = new SiteOverlay($siteOverlayElement);
    }
  }

  constructor($siteOverlayElement) {
    this.$siteOverlayElement = $siteOverlayElement;
    this.bindEvents();
  }

  bindEvents() {
    this.$siteOverlayElement.addEventListener("click", () => {
      document.dispatchEvent(new CustomEvent(MenuDrawer.menuDrawerClosedEventName));
    });
  }
}

export { SiteOverlay };
